import { ajax } from 'rxjs/ajax';
import { map } from 'rxjs/operators';
import {sessionActions} from "../domains/session/redux";
import {termsActions} from "../domains/terms/redux";

export const getJson = ({url}) => {
    return ajax({
        method: 'GET',
        url: url,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        withCredentials: true,
        responseType: 'json',
    }).pipe(
        map(ajaxResponse => ajaxResponse.response)
    )
}

export const postJson = ({url, body, ...otherParams}) => {
    return ajax({
        method: 'POST',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: body,
        withCredentials: true,
        ...otherParams,
    })
}

export const putJson = ({url, body}) => {
    return ajax({
        method: 'PUT',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: body,
        withCredentials: true,
    })
}

export const deleteJson = ({url}) => {
    return ajax({
        method: 'DELETE',
        url: url,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        withCredentials: true,
    })
}

// LEGACY
// export const getJsonWithBasicAuth = ({url, username, password}) => {
//     return ajax.getJSON(url, {
//         'Authorization': 'Basic ' + btoa(unescape(encodeURIComponent(username+':'+password))),
//         'X-Requested-With': 'XMLHttpRequest',
//     })
// }
//
// export const putJsonWithBasicAuth = ({url, username, password, body}) => {
//     return ajax.put(url, body, {
//         'Authorization': 'Basic ' + btoa(unescape(encodeURIComponent(username+':'+password))),
//         'Content-Type': 'application/json',
//         'X-Requested-With': 'XMLHttpRequest',
//     })
// }
//
// export const postJsonWithBasicAuth = ({url, username, password, body}) => {
//     return ajax.post(url, body, {
//         'Authorization': 'Basic ' + btoa(unescape(encodeURIComponent(username+':'+password))),
//         'Content-Type': 'application/json',
//         'X-Requested-With': 'XMLHttpRequest',
//     })
// }
//
// export const postFormWithBasicAuth = ({url, username, password, formData}) => {
//     return ajax.post(url, formData, {
//         'Content-Type': 'application/x-www-form-urlencoded',
//         'Authorization': 'Basic ' + btoa(unescape(encodeURIComponent(username+':'+password))),
//         'X-Requested-With': 'XMLHttpRequest',
//     })
// }

// Legacy aliases (for backward compatibility during migration)
export const getJsonWithAuth = ({url, state}) => getJson({url});
export const postJsonWithAuth = ({url, body, state, ...otherParams}) => postJson({url, body, ...otherParams});
export const putJsonWithAuth = ({url, body, state}) => putJson({url, body});
export const deleteWithAuth = ({url, state}) => deleteJson({url});

/**
 * Checks if the error in the response is a 401 and if it is emits the logout-action
 * to clear the session and go back to the start page.
 */
export const errorHandlingWithLogoutCheck = (error, otherErrorsAction, alternateErrorMessage) => {
    if (error.status === 401) {
        return [sessionActions.logOut()]
    }
    if (error.status === 412) {
        return [termsActions.fetchStatus(), ...otherErrorsAction]
    }
    console.log(error)
    otherErrorsAction[0].errorMessage = errorMessage(error, alternateErrorMessage);
    return otherErrorsAction;
}

export const errorMessage = (error, alternateErrorMessage) => {
    console.log('error:', error);
    return (error && error.response && error.response.code === 9004 && 'Regelfel: ' + error.response.message)
        || (error && error.response && error.response.code === 9002 && 'Indatafel: ' + error.response.message)
        || (error && error.response && error.response.code === 9005 && 'Fel: ' + error.response.message)
        || (error && error.response && error.response.code === 9001 && 'Fel: ' + error.response.message)
        || (error && error.response && error.response.code === 9000 && 'Serverfel: ' + error.response.message)
        || (error && error.response && error.response.code === 9006 && 'Åtkomstfel: ' + error.response.message)
        || (error && typeof error === 'string' && error)
        || alternateErrorMessage
}